import { useContext } from "react";
import { LanguageContext } from "@eriksdigital/atomic-ui/components";

export const useBasenamePath = (): string => {
  const { language } = useContext(LanguageContext) as { language: any };
  return `/${language}/o-ring-selector`;
};
